<template>
  <div class="ec-line002">
    <div class="flex flex-col lg:flex-row lg:flex-wrap lg:text-lg lg:bg-white">
      <div class="ec-line002__img">
        <!-- <img :src="data.img" :alt="data.name" /> -->
        <the-carrousel :data="slides" :name="data.name" />
      </div>
      <div class="ec-line002__block">
        <h1 class="ec-line002__title">{{ data.name }}</h1>
        <div class="ec-line002__description">
          <h2>{{ $t('ec-line002.content.description') }}</h2>
          <text-ellipsis class="with-more-btn" :rows="4" :inline="isShowMore" :action="showShowMoreButton">
            <span class="text-base lg:text-lg leading-normal align-top whitespace-pre-wrap">{{
              data.product_caption
            }}</span>
          </text-ellipsis>
          <span :class="['ec-line002__description__more-btn', { 'lg:inline': isShowButton }]" @click="onShowMore">
            {{ $t('ec-line002.content.showMore') }}
          </span>
        </div>
        <div class="ec-line002__category">{{ data.category }}</div>
        <div class="ec-line002__price">
          <slot name="price"></slot>
          <el-tag v-if="data.sale_type === Constants.SALE_TYPE.SUBSCRIPTION" class="text-sm leading-normal h-auto">{{
            $t('ec-line002.content.subscriptionProduct')
          }}</el-tag>
        </div>
        <div class="ec-line002__stock mt-2 text-red-150" v-if="!sku1List.length && !sku2List.length">
          {{ $t('ec-line002.content.notSkuVisible') }}
        </div>
        <div class="ec-line002__stock mt-2" v-else-if="!skuItemSelected.stock_unlimited">
          <span v-if="skuItemSelected.stock >= 6" class="text-black">{{ $t('ec-line002.content.inStock') }}</span>
          <span v-else-if="skuItemSelected.stock > 0" class="text-red-150">{{
            $t('ec-line002.content.remaining', { stock: skuItemSelected.stock })
          }}</span>
          <span v-else class="text-red-150">{{ $t('ec-line002.content.outOfStock') }}</span>
        </div>

        <template v-if="data.sale_type === Constants.SALE_TYPE.BOTH && sku1List.length && sku2List.length">
          <sale-type-selected
            :value="saleTypeSelected"
            @input="saleTypeSelected = $event"
            class="mt-10 ec-line002__sku"
          ></sale-type-selected>
        </template>
        <template v-if="!isProductOnly && sku1List.length && sku2List.length">
          <sku-list
            class="ec-line002__sku mt-5"
            :label="skuName1"
            :items="sku1List"
            :selected.sync="skuSelected[0]"
          ></sku-list>
          <sku-list
            class="ec-line002__sku mt-3"
            :label="skuName2"
            :items="sku2List"
            :selected.sync="skuSelected[1]"
          ></sku-list>
        </template>

        <div class="w-full mt-8 text-center">
          <el-button
            class="submit-btn"
            :disabled="
              (!isProductOnly && !skuItemSelected && !saleTypeSelected) ||
              outOfStock ||
              (!sku1List.length && !sku2List.length)
            "
            @click="submit"
            >{{ labelButton }}</el-button
          >
          <div class="anygift">
            <div class="gift-ui" data-anygift></div>
          </div>
        </div>
      </div>
      <div class="ec-line002__caption">
        <h2 class="px-4">{{ $t('ec-line002.content.description') }}</h2>
        <div class="text-base lg:text-lg leading-normal align-top whitespace-pre-wrap px-4">
          {{ data.product_caption }}
        </div>
      </div>
    </div>
    <div class="ec-line002__body" v-html="data.description_detail"></div>
  </div>
</template>

<script>
import SkuList from '../SkuList.vue'
import TheCarrousel from '../TheCarrousel.vue'
import SaleTypeSelected from '../SaleTypeSelected.vue'
import { ENV_KEY } from '@/constants/env'
import TextEllipsis from '@/components/TextEllipsis.vue'
import store from '@/store'

window.AnyGift = {
  productCode: '',
  storeId: '',
}

export default {
  components: { TheCarrousel, SkuList, SaleTypeSelected, TextEllipsis },
  props: {
    data: { type: Object, default: () => {} },
    items: { type: Array, default: () => [] },
    labelSubmit: { type: String, default: () => '' },
    labelRoute: { type: String, default: () => '' },
    skuItemSelection: {
      type: Object,
      default: () => ({}),
    },
    saleTypeSelection: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      skuSelected: [null, null],
      saleTypeSelected: this.Constants.SALE_TYPE.SUBSCRIPTION,
      isShowMore: false,
      isShowButton: false,
      anyGiftScript: null,
      dataScript: null,
      shopId: null,
    }
  },
  computed: {
    slides() {
      return this.data?.product_images?.map((i) =>
        Object.assign({ img: `${this.$store.getters['env/GET_KEY'](ENV_KEY.IMAGE_API)}/${i.file_name}` })
      )
    },
    isProductOnly() {
      return (
        this.data.product_sku?.length === 1 &&
        !this.data.product_sku[0].sku_set_item1_id &&
        !this.data.product_sku[0].sku_set_item1_id
      )
    },
    skuName1() {
      return this.data.product_sku && this.data.product_sku[0].sku_item_parent_name_1
    },
    skuName2() {
      return this.data.product_sku && this.data.product_sku[0].sku_item_parent_name_2
    },
    sku1List() {
      const filterList =
        (this.skuSelected[1] &&
          this.data.product_sku.filter((i) => i.sku_set_item2_id === this.skuSelected[1] && i.visible)) ||
        this.data.product_sku
      return this.$_.uniqBy(filterList, 'sku_set_item1_id').map((i) =>
        Object.assign({ id: i.sku_set_item1_id, name: i.sku_set_item_name1 })
      )
    },
    sku2List() {
      const filterList =
        (this.skuSelected[0] &&
          this.data.product_sku.filter((i) => i.sku_set_item1_id === this.skuSelected[0] && i.visible)) ||
        this.data.product_sku
      return this.$_.uniqBy(filterList, 'sku_set_item2_id').map((i) =>
        Object.assign({ id: i.sku_set_item2_id, name: i.sku_set_item_name2 })
      )
    },
    skuItemSelected() {
      return this.data.product_sku?.find(
        (i) => i.sku_set_item1_id === this.skuSelected[0] && i.sku_set_item2_id === this.skuSelected[1]
      )
    },
    labelButton() {
      const sale_type =
        this.data.sale_type === this.Constants.SALE_TYPE.BOTH ? this.saleTypeSelected : this.data.sale_type
      const isSubscription = sale_type === this.Constants.SALE_TYPE.SUBSCRIPTION
      return this.items.some((i) => i.id === this.skuItemSelected?.id && i.subscription === isSubscription)
        ? this.labelRoute
        : this.labelSubmit
    },
    outOfStock() {
      return (this.skuItemSelected && !this.skuItemSelected.stock_unlimited && !this.skuItemSelected.stock) || false
    },
  },
  watch: {
    data(val) {
      this.onSelectSku1(val.product_sku[0].sku_set_item1_id)
      this.onSelectSku2(val.product_sku[0].sku_set_item2_id)
    },
    skuItemSelected: {
      handler(val) {
        if (val) {
          const hostname = window.location.hostname
          // st1. st1- dv1. などを削除
          const noPrefix = hostname.replace(/^(st|dv)[1-9][-.]/i, '')
          const storeId = noPrefix.split('.').slice(0, -1).join('.')
          window.AnyGift.productCode = val.product_code
          window.AnyGift.storeId = storeId
          this.createAnyGiftElement()
        }
        this.$emit('update:sku-item-selection', val)
      },
      immediate: true,
    },
    saleTypeSelected: {
      handler(val) {
        this.$emit('update:sale-type-selection', val)
      },
      immediate: true,
    },
  },
  mounted() {
    this.shopId = store.getters['env/GET_KEY'](ENV_KEY.SHOP_ID)
  },
  destroyed() {
    this.removeAnyGiftElement()
  },
  methods: {
    createAnyGiftElement() {
      this.removeAnyGiftElement()

      this.$nextTick(() => {
        this.anyGiftScript = document.createElement('script')
        this.anyGiftScript.async = true
        this.anyGiftScript.src = 'https://d1ioo46r7yo3cy.cloudfront.net/store.js'
        document.head.appendChild(this.anyGiftScript)

        this.dataScript = document.createElement('script')
        this.dataScript.type = 'text/javascript'
        this.dataScript.async = true
        this.dataScript.props = {
          AnyGift: window.AnyGift,
        }
        document.head.appendChild(this.dataScript)
      })
    },
    removeAnyGiftElement() {
      if (this.anyGiftScript) {
        this.anyGiftScript.remove()
        this.anyGiftScript = null
      }
      if (this.dataScript) {
        window.AnyGift.productCode = ''
        window.AnyGift.storeId = ''
        this.dataScript.remove()
        this.dataScript = null
      }
    },
    submit() {
      this.$emit('submit', {
        ...this.skuItemSelected,
        subscription:
          this.data.sale_type === this.Constants.SALE_TYPE.BOTH
            ? this.saleTypeSelected === this.Constants.SALE_TYPE.SUBSCRIPTION
            : this.data.sale_type === this.Constants.SALE_TYPE.SUBSCRIPTION,
      })
    },
    onSelectSku1(id) {
      this.skuSelected[0] = id
    },
    onSelectSku2(id) {
      this.skuSelected[1] = id
    },
    onShowMore() {
      this.isShowMore = true
      this.isShowButton = false
    },
    showShowMoreButton(el) {
      if (el.$el.offsetHeight < el.$el.scrollHeight) {
        this.isShowButton = true
      } else {
        this.isShowButton = false
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/css/pages/ec-line002.scss';
</style>
